import validate from "/usr/src/app/content/n3-spas-273e8024-ec29-42da-b5ec-6dbe0b855e33/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-273e8024-ec29-42da-b5ec-6dbe0b855e33/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}